import { Campaign } from "../domain/campaign";
import { getAllCampaignsService } from "../infrastructure/services/getAllCampaignsService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAllCampaigns = {
    async execute(): Promise<Campaign[]> {
        return await getAllCampaignsService.execute(await tokenValidation.execute());
    },
};


